import React from "react";

import BoardHeader from "../BoardHeader/BoardHeader";
import HistoryItems from "./HistoryItems";
import "./Feeds.scss";
import SelectDatePicker from "../../../../features/myTask/components/Filters/SelectDatePicker";
import Loader from "../../../../components/Loader";
import BoardDetailController from "../../controllers/BoardDetailController";
import { useBoardFeedsState } from "./hooks/useBoardFeedsState";

const Feeds = ({ showCardPopup = false }) => {
  const {
    boardHeaderData,
    boardId,
    cardId,
    isMilestoneView,
    isLoading,
    marginTopClass,
    ownerId,
    setLoading,
    workflowId,
  } = useBoardFeedsState();

  return (
    <>
      <BoardDetailController
        boardId={boardId}
        cardId={cardId}
        cardsOnBoard={[]}
        showCardPopup={showCardPopup}
      />
      {isLoading ? (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      ) : (
        <>
          <BoardHeader
            boardName={boardHeaderData}
            boardId={boardId}
            ownerId={ownerId}
            workflowId={workflowId}
            setLoading={setLoading}
          />

          <div className={marginTopClass + " feeds-content-div"}>
            <div className="d-flex justify-content-space-between mb-4 ">
              <div className="d-flex">
                <p className="heading-feeds-tab mr-32">Feeds</p>
              </div>
              <div className="ml-3 d-flex align-items-center">
                <SelectDatePicker />
              </div>
            </div>

            <div
              className={`feeds-scroll ${
                isMilestoneView
                  ? "feeds-scroll-milestone"
                  : "feeds-scroll-no-milestone"
              }`}
            >
              <HistoryItems />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Feeds;
